/**
 * Safely gets a nested property from an object using a dot-notation path
 * @param {Object} obj - The object to retrieve the property from
 * @param {String} path - The path to the property (e.g. "user.address.street")
 * @param {*} defaultValue - The default value to return if the property is not found
 * @returns {*} The property value or the default value
 */
export const getNestedProperty = (obj, path, defaultValue = "-") => {
  const result = path
    .split(".")
    .reduce(
      (acc, part) =>
        acc && acc[part] !== undefined ? acc[part] : defaultValue,
      obj
    );
  return result;
};

export default {
  install(Vue) {
    Vue.prototype.$getNestedProperty = getNestedProperty;

    Vue.mixin({
      methods: {
        getNestedProperty,
      },
    });
  },
};
